import type { ISportsData } from '@modules/common/sportsData/types';

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { hasPartialUpdates } from '@utils/hasPartialUpdates';

interface IInitialState {
  sportsDataFormState: ISportsData;
  sportsDataConfig: {
    isSelectorChanged: boolean;
    isSportsDataError: boolean;
  };
}

const initialState: IInitialState = {
  sportsDataConfig: {
    isSelectorChanged: false,
    isSportsDataError: false,
  },
  sportsDataFormState: {
    includedSportsConditions: {
      combinator: 'OR',
      sportsDataConditionFields: [],
    },
    excludedSportsConditions: {
      combinator: 'AND',
      sportsDataConditionFields: [],
    },
  },
};

const sportsDataSlice = createSlice({
  initialState,
  name: 'sportsDateSlice',
  reducers: {
    resetIncludedSportsData(state: IInitialState) {
      state.sportsDataFormState.includedSportsConditions =
        initialState.sportsDataFormState.includedSportsConditions;
    },
    resetExcludedSportsData(state: IInitialState) {
      state.sportsDataFormState.excludedSportsConditions =
        initialState.sportsDataFormState.excludedSportsConditions;
    },
    setSportsDataConfig(
      state: IInitialState,
      action: PayloadAction<Partial<IInitialState['sportsDataConfig']>>
    ) {
      if (!hasPartialUpdates(state.sportsDataConfig, action.payload)) {
        return;
      }

      Object.assign(state.sportsDataConfig, action.payload);
    },
    setExcludedSportsData(
      state: IInitialState,
      action: PayloadAction<Partial<ISportsData['excludedSportsConditions']>>
    ) {
      state.sportsDataFormState.excludedSportsConditions = {
        ...state.sportsDataFormState.excludedSportsConditions,
        ...action.payload,
      };
    },
    setIncludedSportsData(
      state: IInitialState,
      action: PayloadAction<Partial<ISportsData['includedSportsConditions']>>
    ) {
      state.sportsDataFormState.includedSportsConditions = {
        ...state.sportsDataFormState.includedSportsConditions,
        ...action.payload,
      };
    },
  },
});

export default sportsDataSlice.reducer;

export const {
  setSportsDataConfig,
  setExcludedSportsData,
  setIncludedSportsData,
  resetIncludedSportsData,
  resetExcludedSportsData,
} = sportsDataSlice.actions;
